import './App.css';
import { Login } from "./components/login";
import { Route, Routes } from 'react-router-dom';
import { About } from './pages/about';
import { Home } from './pages/home';
import { MyProjects } from './pages/myprojects';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { User } from './pages/user';
import { AuthProvider } from './contexts/authContext';
import PrivateRoute from './components/privateRoute';
import { PublicProjects } from './pages/publicProjects';
import { ProjectPrivate } from './pages/projectPrivate';
import { ProjectPublic } from './pages/projectPublic';
import { Tos } from './pages/tos';
import { CommingSoon } from './pages/comingsoon';
import defaultTheme from './components/Themes/defaultTheme';
import {Container, ThemeProvider} from '@mui/material';
import { SignUp } from './components/signup';
import { PrivacyPolicy } from './pages/privacyPolicy';

function App() {

  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  function NoMatch() {
    window.location.replace('/404.html');
    return null;
  }

  return (
    <div className="App">
      <AuthProvider>
        <QueryClientProvider client={client}>
        <ThemeProvider theme={defaultTheme}>
          <Routes>
            <Route path='/' element={<Home />} />
            {/* <Route path='/' element={<CommingSoon />} /> */}
            {/* <Route path="/about" element={<About />} /> */}
            <Route path="/project/:id" element={<PrivateRoute><ProjectPrivate /></PrivateRoute>} />
            <Route path="/p/:id" element={<ProjectPublic />} />
            <Route path="/myprojects" element={<PrivateRoute><MyProjects /></PrivateRoute>} />
            <Route path="/publicprojects" element={<PublicProjects />} />
            <Route path='/user' element={<PrivateRoute><User /></PrivateRoute>} />
            <Route path='/login' element={<Login />} />
            <Route path='/signup' element={<SignUp />} />
            <Route path='/tos' element={<Tos />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/faq'element={<Home scrollToFaq={true} />}/>
            <Route path='/demo'element={<Home scrollToDemo={true} />}/>
            <Route path='/features'element={<Home scrollToFeatures={true} />}/>
            <Route path='*' element={<NoMatch />} />
          </Routes>
          </ThemeProvider>
        </QueryClientProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
